import { Injectable } from '@angular/core';
import { MethodsService } from '../method.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private _wpService: MethodsService
  ) {
  }

  /**
   * @description Obtener toda la información de home
   * @returns Regresa JSON completo de la información home
   */
  getImageFromS3() {
    return this._wpService.get('apimj/general_options?identifier=all&isoptionf=true');
  }

  /**
   * @description Obtener toda la información de MJ
   * @returns Regresa JSON completo de la información home
   */
  getGeneralOptions(identifier = 'all') {
    return this._wpService.get('apimj/general_options?identifier=' + identifier + '&isoptionf=true');
  }

  /**
   * @description Obtener toda información la pagina del parametro
   * @returns Regresa JSON
   */
  getAllDataPage(page) {
    return this._wpService.get('apimj/mainfront/components/' + page );
  }
  /**
   * @description Obtener toda información de banners
   * @returns Regresa JSON de banners
   */
  getBanners(page) {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=banners');
  }

  /**
   * @description Obtener toda información de ventajas
   * @returns Regresa JSON de ventajas
   */
  getAdvantages(page = 'home'): Observable<any> {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=ventajas');
  }

  /**
   * @description Obtener toda información de suscribete
   * @returns Regresa JSON de suscribete
   */
  getSubscribe(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=suscribete');
  }

  /**
   * @description Obtener toda información de testimonios
   * @returns Regresa JSON de testimonios
   */
  getComments(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=testimonios');
  }

  /**
   * @description Obtener toda información de promociones
   * @returns Regresa JSON de promociones
   */
  getPromotions(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=promociones');
  }

  /**
   * @description Obtener toda información de promoción de producto
   * @returns Regresa JSON de proomoción de producto
   */
  getPromoProduct(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=promoproducto');
  }

  /**
   * @description Obtener toda información de productos complementarios
   * @returns Regresa JSON de productos complementarios
   */
  getProdComplement(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=prodcomplement');
  }

  /**
   * @description Obtener toda información del posicionamiento
   * @returns Regresa JSON de posicionamiento
   */
  getPosition(page = 'home') {
    return this._wpService.get('apimj/mainfront/components/' + page + '?identifier=posicionamiento');
  }

  /**
   * @description Obtener toda la información del widget
   * @returns Regresa JSON de widget
   */
  getWidgetOptions(identifier='all') {
    return this._wpService.get('apimj/widgets?identifier=' + identifier + '&isoptionf=1');
  }

}
